import { type SvgIconComponent } from "@mui/icons-material";
import { Avatar, Badge, type SxProps, type Theme } from "@mui/material";
import { imageURL } from "../../http";

export const ImageIcon = ({ image = {}, Fallback, count = 0, variant = "circular", color, sx }: ImageIconProps): JSX.Element => {
    return (
        <Badge color="primary" invisible={!count} overlap="circular" badgeContent={count ? `+${count}` : ""}>
            <Avatar
                src={image.src ? imageURL(image.src) : undefined}
                alt={image?.title}
                variant={variant}
                sx={{ bgcolor: color, ...sx }}
                slotProps={{ img: { sx: { objectFit: "contain" } } }}
            >
                <Fallback color={(color as any) ?? "disabled"} />
            </Avatar>
        </Badge>
    );
};

interface ImageIconProps {
    color?: string;
    image?: Image;
    Fallback: SvgIconComponent;
    count?: number;
    variant?: "square" | "rounded" | "circular";
    sx?: SxProps<Theme>;
}

interface Image {
    src?: string;
    title?: string;
}

interface EnumIconProps {
    icon: SvgIconComponent;
    count?: number;
    variant?: "square" | "rounded" | "circular";
    color?: string;
    alt?: string;
    sx?: SxProps<Theme>;
}

export const EnumIcon = ({ icon, count = 0, variant = "circular", ...rest }: EnumIconProps): JSX.Element => {
    return <ImageIcon Fallback={icon} count={count} variant={variant} {...rest} />;
};

export type DomainImageProps = Omit<ImageIconProps, "Fallback" | "variant">;
